var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c(
        "a",
        {
          staticClass: "text-black font-bold",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.editEvent.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.organization.name) + "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v("\n        " + _vm._s(_vm.organization.url) + "\n    ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }